import { Upload, X } from 'lucide-react';
import { ACCENT as SECTION_COLOR } from '../lib/uiTokens';
import DokladUploader from '../components/doklady/DokladUploader';

/**
 * Desktop modal wrapper kolem sdíleného DokladUploader.
 * Chrome (hlavička + ×) + předvybrané soubory z inboxu; veškerá logika
 * (staging seskupení, multi-page, async upload) je v DokladUploader.
 */
export default function DokladyUploadModal({ soubory, cardStyle, onClose, onNahrano }) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
            style={{ background: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
            <div className="w-full max-w-2xl max-h-[85vh] flex flex-col rounded-2xl overflow-hidden"
                style={{ ...cardStyle }} onClick={(e) => e.stopPropagation()}>

                <div className="flex items-center justify-between px-5 py-3.5 border-b" style={{ borderColor: 'var(--border)' }}>
                    <div className="flex items-center gap-2">
                        <Upload size={18} style={{ color: SECTION_COLOR }} />
                        <h3 className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>Nahrát doklady</h3>
                    </div>
                    <button onClick={onClose} className="p-1.5 rounded-lg hover:bg-black/5 dark:hover:bg-white/10">
                        <X size={18} style={{ color: 'var(--text-tertiary)' }} />
                    </button>
                </div>

                <DokladUploader
                    zdroj="desktop"
                    variant="modal"
                    initialFiles={soubory}
                    onUploaded={onNahrano}
                    onClose={onClose}
                />
            </div>
        </div>
    );
}
